import React from 'react';

import { Icon } from '@/components/memo';
import { checkmarkCircle } from 'ionicons/icons';

import './Benefits.css';

const Benefits: React.FC = () => {
  const benefits = [
    'Unlimited appointments',
    'Unlimited patient reminders',
    'Exclusive booking website',
    'All features included'
  ];

  return (
    <div className="benefits">
      {benefits.map((benefit, index) => (
        <div className="benefits__item" key={`benefit-${index}`}>
          <Icon
            className="benefits__icon"
            icon={checkmarkCircle}
            color="success"
          />
          <p className="benefits__text">{benefit}</p>
        </div>
      ))}
    </div>
  );
};

export default Benefits;
